import { render, staticRenderFns } from "./home.view.vue?vue&type=template&id=4c7741aa&scoped=true"
import script from "./home.view.vue?vue&type=script&lang=js"
export * from "./home.view.vue?vue&type=script&lang=js"
import style0 from "./home.view.vue?vue&type=style&index=0&id=4c7741aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7741aa",
  null
  
)

export default component.exports